
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Image = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M17.1,4.9V3.2A1.1,1.1,0,0,0,16,2.1H9A1.1,1.1,0,0,0,7.9,3.2V4.9H2.8V19.9H18.9a3.3,3.3,0,0,0,3.3-3.3V4.9Zm3.6,11.7a1.8,1.8,0,0,1-1.8,1.8H4.3V6.5H9.4V3.6h6.2V6.4h5.1Z"></path>
            <path d="M12.5,7.1a4.7,4.7,0,0,0-4.7,4.7,4.8,4.8,0,0,0,4.7,4.8,4.8,4.8,0,0,0,4.7-4.8A4.7,4.7,0,0,0,12.5,7.1Zm0,8a3.3,3.3,0,1,1,3.2-3.3A3.2,3.2,0,0,1,12.5,15.1Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Image.defaultProps = {
  title: 'Image',
};

export default Image;
